import { isValidDate } from '../../../date';
import { ValueDecoder } from './types';

export const decodeDate: ValueDecoder = (value) => {
  if (isValidDate(value)) {
    return new Date(value);
  }
  return value;
};
